/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Map marker data for a structure
 */
export interface AnalyticMapData { 
    /**
     * Internal AnalyticMapData Key
     */
    id?: number;
    /**
     * Internal AnalyticValue Key
     */
    analyticValueId?: number;
    /**
     * Properties of the map marker, including filename, color, and size
     */
    icon?: { [key: string]: string; };
    /**
     * Latitude coordinate of the map marker
     */
    latitude?: number;
    /**
     * Longitude coordinate of the map marker
     */
    longitude?: number;
    /**
     * Content that will be displayed above the map marker when hovered
     */
    mouseOver?: string;
    /**
     * display the geometry location for a structure
     */
    shape?: string;
    /**
     * jsonString to display additional information on the MapView
     */
    miscData?: string;
}

